var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e1ecef;}.b{fill:#fff;}.c{fill:#1d9ebd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-365 -1690)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    transform: "translate(365 1690)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 27,
    height: 12,
    rx: 6,
    transform: "translate(380 1719)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 27,
    height: 12,
    rx: 6,
    transform: "translate(380 1750)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 12,
    rx: 6,
    transform: "translate(412 1719)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 26,
    height: 12,
    rx: 6,
    transform: "translate(412 1750)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 26,
    height: 12,
    rx: 6,
    transform: "translate(443 1719)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 12,
    rx: 6,
    transform: "translate(443 1750)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 13,
    rx: 6.5,
    transform: "translate(412 1734)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 13,
    rx: 6.5,
    transform: "translate(412 1765)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 13,
    rx: 6.5,
    transform: "translate(443 1734)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26,
    height: 13,
    rx: 6.5,
    transform: "translate(443 1765)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 27,
    height: 13,
    rx: 6.5,
    transform: "translate(380 1734)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 27,
    height: 13,
    rx: 6.5,
    transform: "translate(380 1765)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.2e7e596468b436bafee288ecd006f8aa.svg";
export { ForwardRef as ReactComponent };